export enum DocumentType
{
	PHOTO = "PHOTO",
	PLANIMETRY = "PLANIMETRY",
	ATTACHMENT = "ATTACHMENT",
	TOUR_3D = "TOUR_3D",
	OTHER = "OTHER",
	AI_REPORT = "AI_REPORT",
}

export interface Document
{
	id: string
	documentNumber: string
	name: string
	uploadDate: string
	documentType: DocumentType
	isPublic: boolean
	brand?: {
		id?: string | null
		name?: string | null
	} | string | null
	brandId?: string | null
	brandName?: string | null
}
